<template>
  <div id="terms-of-use-container" class="container">
    <div class="row">
      <div class="materialized col-xs-12">
        <h2 class="title-24">Accept Terms of Use</h2>
      </div>
    </div>

    <div class="row">
        <div class="col-xs-12 col-sm-8 materialized">
          <ul class="list-group">
            <li class="list-group-item">
              <div class="input-group">
                <span class="md-checkbox">
                  <input type="checkbox"
                    name="subscribeToFitperks"
                    id="subscribeToFitperks"
                    :checked="value.subscribeToFitperks"
                    v-on:click="event => updateValue('subscribeToFitperks', event.target.checked)"
                    >
                  <label for="subscribeToFitperks">
                    I would like to sign up for the Fit:Perks® program.
                    <a :href="fitPerksTermsURL" target="_blank">
                      <span class="checkbox-link"> Learn more about Fit:Perks®  </span>
                    </a>
                  </label>
                </span>
              </div>
            </li>

            <li class="list-group-item">
              <div class="input-group">
                <span class="md-checkbox">
                  <input type="checkbox"
                    name="acceptTerms"
                    id="acceptTerms"
                    v-on:click="event => updateValue('acceptTerms', event.target.checked)"
                    :checked="value.acceptTerms"
                    >
                  <label for="acceptTerms">
                    I agree to the 24hourfitness.com
                    <a :href="termsOfUseURL" target="_blank">
                      <span class="checkbox-link"> Terms of Use </span>
                    </a>
                  </label>
                </span>
              </div>
            </li>
          </ul>

          <p>We will automatically enroll you to receive news and offers from 24 Hour Fitness upon confirmation of your account</p>
          <p>
            You can change this setting at any time by clicking on the Change Preferences tab. (See also
            <a :href="privacyPolicyURL" target="_blank"><span class="checkbox-link">Privacy Policy</span></a>)
          </p>

        </div>

        <div class="col-xs-12 col-sm-3 col-sm-offset-1 buttons-container">
          <div class="form-group materialized">

            <button class="btn btn-primary"
                    v-on:click="submitForm()"
                    :disabled="!value.acceptTerms || isSubmitting || !areAllFormsValid">
              <i v-show="isSubmitting"
                class="fa fa-cog fa-spin fa-fw margin-bottom security-saving-icon"></i>
              Submit
            </button>

            <button class="btn btn-default" v-on:click="$emit('cancelRegistration')">Cancel</button>

          </div>
        </div>
    </div>

  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'terms-of-use',
    props: {
      reEnableSubmitButton: false,
      areAllFormsValid: {
        type: Boolean,
        default: false
      },
      value: {
        type: Object,
        default: function () {
          return {
            subscribeToFitperks: false,
            acceptTerms: false
          }
        }
      }
    },
    data () {
      return {
        isSubmitting: false,
        termsOfUseURL: 'https://24hourfitness.com/company/policies/privacy/privacy_policy.html',
        fitPerksTermsURL: 'https://www.24hourfitness.com/fitperks/#terms',
        privacyPolicyURL: 'https://24hourfitness.com/company/policies/privacy/privacy_policy.html'
      }
    },
    methods: {
      updateValue (key, value) {
        let valueCopy = _.cloneDeep(this.value)
        valueCopy[key] = value
        this.$emit('input', valueCopy)
      },

      submitForm () {
        this.isSubmitting = true
        this.$emit('submitForm')
      },

      cancelRegistration () {
        this.$emit('cancelRegistration')
      }
    },
    watch: {
      reEnableSubmitButton: function (value) {
        if (value) {
          this.isSubmitting = false
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '~my-account-common-css/stylesheets/materialized.scss';
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss';

  #terms-of-use {
    background-color: #D5D2CA;
  }

  #terms-of-use-container {

    margin-bottom: 30px;

    > .row {

      &:nth-child(2) {

        background-color: #FFFFFF;
        border-top: 1px solid #eb2131;
        margin: auto 0;
        width: 100%;

        @media (min-width: $screen-sm-min) {

          display: table;
          overflow: auto;

          &::before, &::after {

            content: none;

          }

        }

        > div {

          @media (min-width: $screen-sm-min) {

            display: table-cell;
            float: none;

          }

          &:first-child {

            padding: 20px 15px;

            p {

              margin-left: 50px;
              margin-bottom: 0;
              font-size: 0.8em;

            }

          }

          &:nth-child(2) {

            .form-group {

              display: flex;
              flex-direction: column;
              padding: 10px 15px;
              justify-content: space-evenly;

              @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {

                padding-top: 40px;

              }

              button {

                &:last-child {

                  margin-top: 15px;

                  @media (min-width: $screen-sm-min) {

                    margin-top: 0;

                  }

                  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {

                    margin-top: 15px;

                  }

                }

              }

              @media (min-width: $screen-sm-min) {

                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;

              }

            }

          }

          .list-group {
            margin: 0;
          }

          .list-group-item {
            border: 0 !important;
            padding: 0;
          }

          .md-checkbox {
            padding-top: 12px;
          }

          .checkbox-link {
            cursor: pointer;
            color: #0067B1;
            text-decoration: underline;
            font-weight: bold;
            font-size: 1em;
          }

        }

      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/components/TermsOfUse.vue